import * as React from 'react';

import * as styles from './styles.css';

export interface IOfferSummaryInfoProps {
  children: React.ReactNode;
}

export const OfferSummaryInfoLayout: React.FC<React.PropsWithChildren<IOfferSummaryInfoProps>> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
